import { HttpHeaders } from '@angular/common/http';
import { UserInfo } from '@app/_models/userInfo'

export const headervalue = {

   header: {
      'Content-Type': 'application/json'
   },

   headerWithJwt: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
   },
   headerWithOnlyJwt: {     
      'Authorization': 'Bearer ' + localStorage.getItem('token')
   },
   headerWithJwtImage: {
      'Content-Type': 'image/*',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
   },

   
};

